// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4de69c95","132":"3906c891","139":"b12a2534","898":"f3be1424"}[chunkId] + ".chunk.js";
};